import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

//
import { CookiesProvider } from 'react-cookie';
import App from './App';

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <BrowserRouter>
    <CookiesProvider>
      <App />
    </CookiesProvider>
    </BrowserRouter>
  </HelmetProvider>
);
